import React from "react";
import img2 from './images/Senor.jpg';

export default function Cardgage() {
    return(
        <div>
        <img src={img2} alt="A cool guy telling you about numbers" />
        </div>
    );
}